import * as React from 'react'
import { Map as ReactLeafletMap } from 'react-leaflet'

export const LeafletMapContext = React.createContext<ReactLeafletMap | null>(null)
export const LeafletMapProvider = LeafletMapContext.Provider

export function useLeafletMap(): ReactLeafletMap | null {
	return React.useContext(LeafletMapContext)
}
